import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType } from "../../../isp._comun/iu/_principal/constantesIuPrin";

export default class VentanaQueryClientes extends Ventana {
    constructor() {
        super();
        this.id = DialogType.QUERY_CLIENTES;
        // this.id = VentanaQueryClientes.constructor.name;
        // this.ventanaCargando = null;
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaQueryClientes)) {
            return false;
        }
        return true;
    }

    clonar() {
        const nuevaVentana = new VentanaQueryClientes();
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.id = this.id;
        // nuevaVentana.ventanaCargando = this.ventanaCargando;
        return nuevaVentana;
    }
}
